import React, { useState, useEffect, useRef } from "react";
import ViewIndicadores from "../Indicadores/ViewIndicadores";
import TablaIndicador from "../TablaIndicador/TablaIndicador";
import FichasIndicador from "../FichasIndicador/FichasIndicador";
import { Button } from "antd";
import iconoExcel from "../../assets/images/excel.png";
import iconoJson from "../../assets/images/json.jpg";
import "../ContenidoIndicador/ContenidoIndicador.css";

const ContenidoIndicador = ({ urlInicial, nameView, fichasJson, NameArea, NameTema }) => {
  const [activeTab, setActiveTab] = useState("ficha");
  const [url, setUrl] = useState(urlInicial);
  const fichasRef = useRef(null);
  const tablaRef = useRef(null);

  useEffect(() => {
    setUrl(urlInicial);
  }, [urlInicial]);

  const handleButtonClick = (tab) => {
    setActiveTab(tab);
  };

  const handleExportClick = (type) => {
    if (activeTab === "ficha" && fichasRef.current) {
      // Exportar fichas a Excel (solo Excel)
      if (type === "excel") {
        fichasRef.current.exportToExcel();
      } else {
        alert("Exportación a JSON no está disponible para Ficha técnica.");
      }
    } else if (activeTab === "tabla" && tablaRef.current) {
      // Exportar tabla a Excel o JSON
      if (type === "excel") {
        tablaRef.current.exportToExcel();
      } else if (type === "json") {
        tablaRef.current.exportToJson();
      }
    } else {
      alert("Exportación no disponible para la pestaña seleccionada.");
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <div>
          <Button
            type={activeTab === "ficha" ? "primary" : "default"}
            onClick={() => handleButtonClick("ficha")}
          >
            Ficha técnica
          </Button>
          <Button
            type={activeTab === "tabla" ? "primary" : "default"}
            onClick={() => handleButtonClick("tabla")}
          >
            Tabla
          </Button>
          <Button
            type={activeTab === "grafico" ? "primary" : "default"}
            onClick={() => handleButtonClick("grafico")}
          >
            Gráfico
          </Button>
        </div>

        {activeTab !== "grafico" && (
          <div className="ContenedorDescargar">
            <p className="tituloDescargar">Descargar</p>
            <div className="contenedorIconos">
              <img
                className="iconoExcel"
                onClick={() => handleExportClick("excel")}
                src={iconoExcel}
                alt="Exportar a Excel"
              />
              {activeTab === "tabla" && (
                <img
                  className="iconoJson"
                  onClick={() => handleExportClick("json")}
                  src={iconoJson}
                  alt="Exportar a JSON"
                />
              )}
            </div>
          </div>
        )}
      </div>

      {activeTab === "grafico" && <ViewIndicadores url={url} />}
      {activeTab === "tabla" && (
        <TablaIndicador nombre_vista={nameView} ref={tablaRef} />
      )}
      {activeTab === "ficha" && (
        <FichasIndicador fichasJson={fichasJson} NameArea={NameArea} NameTema={NameTema} ref={fichasRef} />
      )}
    </div>
  );
};



export default ContenidoIndicador;